import { WorldCheckpoint } from './objects/WorldCheckpoint';
import { WorldCoin } from './objects/WorldCoin';
import { WorldCollider } from './objects/WorldCollider';
import { WorldDestructable } from './objects/WorldDestructable';
import { WorldExit } from './objects/WorldExit';
import { WorldObject } from './objects/WorldObject';
import { WorldPickup, WorldPickupWeapon } from './objects/WorldPickup';
import { WorldProjectile } from './objects/WorldProjectile';

const WORLDOBJECTS = {
  destructable: WorldDestructable,
  pickup: WorldPickup,
  coin: WorldCoin,
  checkpoint: WorldCheckpoint,
  collider: WorldCollider,
  exit: WorldExit,
  weapon: WorldPickupWeapon,
  projectile: WorldProjectile,
};

export class WorldRenderer extends Phaser.Events.EventEmitter {
  constructor(scene, map, collisionGroups) {
    super();
    this._scene = scene;
    this._mapdata = map.getMapData();
    this._ignoreCollisions = false;
    this._collisionGroups = collisionGroups;

    this._mapdata.backgroundLayers.forEach((layer) => {
      const container = scene.add.layer();
      layer.tiles.forEach((t) => {
        const tile = scene.add.image(t.x, t.y, t.sprite.sheet, t.sprite.frame).setOrigin(0, 1);
        if (layer.scrollspeed) tile.setScrollFactor(layer.scrollspeed.x, 1);
        container.add(tile);
      });
    });

    this._worldLayer = scene.add.layer();

    // render world objects
    this._mapdata.objects.forEach((o) => this.spawnWorldObject(o.type, o));

    this._mapdata.foregroundLayers.forEach((layer) => {
      const container = scene.add.layer();
      layer.tiles.forEach((t) => {
        const tile = scene.add.image(t.x, t.y, t.sprite.sheet, t.sprite.frame).setOrigin(0, 1);
        if (layer.scrollspeed) tile.setScrollFactor(layer.scrollspeed.x, 1);
        container.add(tile);
      });
    });

    scene.cameras.main.setBackgroundColor(this._mapdata.skyColour);
  }

  // =============================================================================================
  // ADD CHARCTERS
  // =============================================================================================

  addHeroCharacter(hero) {
    this._worldLayer.add(hero);
  }

  addEnemyCharacter(enemy) {
    this._worldLayer.add(enemy);
  }

  // =============================================================================================
  // SPAWN OBJECTS
  // =============================================================================================

  spawnCoins(count, x, y) {
    let i = count;
    while (i--) {
      const tx = x + Math.random() * 128 - 64;
      const ty = y + Math.random() * 16 - 8;
      const coin = this.spawnWorldObject('coin', { x: tx, y: ty, lifespan: 5 });
      coin.setVelocity(tx > 0 ? 150 : -150, ty > 0 ? 50 : -50);
      coin._bodyCollider.id = 'coinspawned';
    }
  }

  spawnWeapon(id, x, y) {
    this.spawnWorldObject('weapon', { x, y, name: id });
  }

  spawnPickup(pickupid, x, y) {
    this.spawnWorldObject('pickup', { x, y, name: pickupid });
  }

  spawnProjectile(config) {
    this.spawnWorldObject('projectile', config);
  }

  spawnWorldObject(type, config) {
    const classname = WORLDOBJECTS[type];
    if (classname) return new classname(this._scene, this._worldLayer, config);
    else return new WorldObject(this._scene, this._worldLayer, config);
  }

  update() {
    this._worldLayer.getChildren().forEach((a) => {
      let d = Math.floor(a.hasOwnProperty('depth') ? a.depth : a.y);
      if (a.depth != d) {
        a.setDepth(d);
      }
    });
  }
}
